let debugEnabled = false;

export const offstreetDebug = {
	enable: () => {
		debugEnabled = true;
		console.log("[offstreet] Debug enabled");
	},
	disable: () => {
		debugEnabled = false;
		console.log("[offstreet] Debug disabled");
	},
	isEnabled: () => debugEnabled,
};

export const debugLog = (label: string, data: unknown) => {
	if (debugEnabled) {
		console.log(`[offstreet] ${label}`, data);
	}
};

if (typeof window !== "undefined") {
	(window as any).offstreet = offstreetDebug;
}
